import { useState, useCallback } from "react";
import { useWallet } from "@stores/wallet.store";
import { createModalHelpers } from "@stores/unified-modal.store";

export const useProfile = () => {
    const [currency, setCurrency] = useState(0);
    const [currentPortfolioItem, setCurrentPortfolioItem] = useState(0);
    const [isMenuVisible, setIsMenuVisible] = useState(false);

    // Get modal states and actions from the unified modal store using our helper
    const {
        referal,
        disconnect,
        select,
        import: importModal,
        mobile,
        create,
        connect,
        toggleModal,
        openModal,
        closeModal,
    } = createModalHelpers();

    // Get wallet data directly from the enhanced wallet store
    const { currentWallet, currencies, portfolioItems, fetchBalances, fetchPortfolioItems } = useWallet();

    const handleChooseCurrency = (index: number) => {
        setCurrency(index);
        setIsMenuVisible(false);
    };

    // Refresh wallet data function - using useCallback to prevent unnecessary re-renders
    const refreshWalletData = useCallback(() => {
        // Check if we have a wallet before trying to fetch data
        if (currentWallet && currentWallet.friendlyAddress) {
            fetchBalances();
            fetchPortfolioItems();
        } else {
        }
    }, [currentWallet, fetchBalances, fetchPortfolioItems]);

    return {
        currency,
        setCurrency,
        currentPortfolioItem,
        setCurrentPortfolioItem,
        isMenuVisible,
        setIsMenuVisible,
        handleChooseCurrency,
        portfolioItems,
        currencies,
        refreshWalletData,
        wallet: currentWallet,

        // Modal states
        modals: {
            referal,
            disconnect,
            select,
            import: importModal,
            mobile,
            create,
            connect,
        },

        // Modal actions
        toggleModal,
        openModal,
        closeModal,
    };
};
